
 /**
 * Event `Map.FeatureClick`
 *
 * @typedef {Object} MultSceneForApp~Map~Events~FeatureClick
 * @property {string} type - type of event, has value `map.featureclick`
 * @property {String} layerId - ID of layer
 * @property {Object} properties - properties of feature
 */

export default function createEventFeatureClick(layerId, properties) {
    return {
        type: 'map.featureclick',
        layerId: layerId,
        properties: properties
    };
}
